import { module as modujs } from "modujs";

import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.$wpcf7Form = this.el.querySelector(".wpcf7-form");
		this.$responseOutput = this.$wpcf7Form.querySelector(".wpcf7-response-output");
		this.$submit = this.$wpcf7Form.querySelector(".wpcf7-submit");

		this.mutationObserver = new MutationObserver((mutationsList, observer) => {
			mutationsList.forEach((mutation) => {
				const status = mutation.target.getAttribute("data-status");
				const ignoredStatuses = ["init", "validating", "resetting"];

				this.$submit.disabled = false;

				if (!ignoredStatuses.includes(status)) {
					this.$responseOutput.classList.add("is-active");

					if (this.timeout != undefined) {
						this.timeout.kill();
					}

					this.timeout = gsap.delayedCall(5, () => {
						this.$responseOutput.classList.remove("is-active");
					});

					if (status == "submitting") {
						this.$submit.disabled = true;

						if (document.querySelector("html").lang == "fr") {
							this.$responseOutput.textContent = "Envoi...";
						} else {
							this.$responseOutput.textContent = "Sending...";
						}
					}
				}
			});
		});

		this.mutationObserver.observe(this.$wpcf7Form, { attributeFilter: ["data-status"] });
	}

	destroy() {
		this.mutationObserver.disconnect();
	}
}
